
<template>
    <div v-if="reservation && reservation.tech_reservations" class="guest-invoices-housekeeping">
        <span v-for="techReservation in reservation.tech_reservations" :key="techReservation.id">
            <guest-invoices-housekeeping-card
                :tech-reservation="techReservation"
                @refreshReservation="refreshReservation"
            />
        </span>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import GuestInvoicesHousekeepingCard from './housekeeping-card.vue';

export default {
    name: 'GuestInvoicesHousekeepingTab',
    components: { GuestInvoicesHousekeepingCard },
    computed: {
        ...mapGetters('guest', ['metadata', 'reservation']),
    },
    methods: {
        refreshReservation(callback) {
            this.$emit('refreshReservations', callback);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../../scss/bootstrap-extended/bootstrap-extended.scss';

.guest-invoices-housekeeping {
    padding-top: 1rem;
    display: grid;
    width: 100%;
    grid-column-gap: 15px;
    grid-row-gap: 15px;
    grid-auto-rows: auto;
    grid-template-columns: repeat(2, 1fr);

    @include media-breakpoint-down(md) {
        display: flex;
        flex-direction: column;
    }
}
</style>
